import {
  P3Configuration,
  P3ConfigurationCategory,
  ProgramHeading,
  RegionPosition
} from 'models/interfaces/P3Configurations';
import {
  ConfigurationPoint,
  ConfigurationBarPoint
} from 'models/interfaces/configurationExport/export';

function getNationalPoints(points: ConfigurationPoint[]) {
  console.log('points nat sorted before othres', points);
  if (points.length > 10) {
    let plusOthers = pointsPlusOthers(points);
    let other = plusOthers.pop();
    console.log('other', other);
    let newPoints = sortConfigurationPoints(plusOthers.slice(0, 9));
    console.log('pluss other 1', newPoints);
    if (other) {
      newPoints.push(other);
    }
    console.log('pluss other', newPoints);
    return newPoints;
  }
  console.log('points nat sorted', points);
  return points.slice(0, 10);
}

function sortConfigurationPoints(points: ConfigurationPoint[]) {
  let points2 = points.sort(function name(c: ConfigurationPoint, d: ConfigurationPoint) {
    const textA = c.value;
    const textB = d.value;
    const nameA = c.label.toLowerCase();
    const nameB = d.label.toLowerCase();
    if (textB - textA === 0) {
      if (nameA < nameB) {
        return -1;
      } else if (nameA > nameB) {
        return 1;
      } else {
        return 0;
      }
      // return nameA > nameB ? -1 : 1;
    }

    return textB - textA;
  });
  console.log('sorted categories2', points2);
  return points2;
}
function getRegionalPoints(points: ConfigurationPoint[]) {
  console.log('points regional sorted', points);
  points = sortConfigurationPoints(points);
  if (points.length > 10) {
    let plusOthers = pointsPlusOthers(points);
    console.log('pluss other', plusOthers);
    return plusOthers;
  }
  console.log('points regional sorted after others', points);
  return points.slice(0, 10);
}
function pointsPlusOthers(points: ConfigurationPoint[]) {
  console.log('poirs outers before', points);
  let small = points.slice(0, 9);
  let large = points.slice(9);
  console.log('small', small);
  console.log('large', large);
  if (large.length > 0) {
    let sum = large.reduce((sum: number, point: ConfigurationPoint) => {
      return sum + point.value;
    }, 0);
    let label = large.length > 1 ? 'Others' : 'Other';
    let others: ConfigurationPoint = {
      id: label,
      label: label,
      value: sum,
      pointsLabel: sum > 1 ? 'points' : 'point'
    };
    small.push(others);
  }
  console.log('sorted categories after others', small);
  return small;
}
function getPoints(categories: P3ConfigurationCategory[], nat: boolean, program: ProgramHeading[]) {
  let points: ConfigurationPoint[] = [];
  if (!categories || categories.length === 0) {
    return points;
  }
  categories.forEach((category: P3ConfigurationCategory) => {
    let value = nat
      ? category.national_purchased_rank_points
      : category.regional_purchased_rank_points;

    let positionValue = program.find(({ headingId }) => headingId === category.category_id);
    let position = '';
    if (positionValue) {
      if (nat) {
        let region = positionValue.region.find(({ name }) => name === 'NAT');
        position = region ? region.position.toString() : '';
      } else {
        let ar: any[] = [];
        positionValue.region.map((x: RegionPosition) => {
          if (x.name != 'NAT' && !ar.includes(x.position)) {
            ar.push(x.position);
          }
        });
        ar = ar.sort((a, b) => a - b);
        position =
          ar.length > 0
            ? ar.length > 1
              ? `${ar[0]}${getOrdinal(ar[0])} to ${ar[ar.length - 1]}${getOrdinal(
                  ar[ar.length - 1]
                )}`
              : `${ar[0]}${getOrdinal(ar[0])}`
            : '';
      }
    }
    let point: ConfigurationPoint = {
      id: category.category_id,
      label: category.category_name,
      value: value,
      pointsLabel: value > 1 ? 'points' : 'point',
      position: position
    };
    points.push(point);
  });

  points = points.filter((x: ConfigurationPoint) => {
    return x.value > 0;
  });
  return sortConfigurationPoints(points);
}
function getOrdinal(cardinal: number) {
  if (cardinal <= 0) {
    return '';
  }
  let lastTwoDigits = cardinal % 100;
  let lastDigit = lastTwoDigits % 10;
  let suffix = '';
  switch (lastDigit) {
    case 1:
      suffix = 'st';
      break;

    case 2:
      suffix = 'nd';
      break;

    case 3:
      suffix = 'rd';
      break;

    default:
      suffix = 'th';
      break;
  }
  if (11 <= lastTwoDigits && lastTwoDigits <= 13) {
    suffix = 'th';
  }
  return suffix;
}
function getPointsData(configuration: P3Configuration) {
  let getPointsData: ConfigurationBarPoint[] = [];
  let regional: ConfigurationBarPoint = {
    id: 'regional',
    value: getSumPoints(configuration.categories, false),
    color: '#3DB4E7'
  };

  getPointsData.push(regional);
  let national: ConfigurationBarPoint = {
    id: 'national',
    value: getSumPoints(configuration.categories, true),
    color: '#27628F'
  };
  getPointsData.push(national);
  return getPointsData;
}
function getSumPoints(categories: P3ConfigurationCategory[], nat: boolean) {
  if (!categories) {
    return 0;
  }
  if (categories.length === 0) {
    return 0;
  }
  return categories.reduce((sum: number, category: P3ConfigurationCategory) => {
    return (
      sum +
      (nat ? category.national_purchased_rank_points : category.regional_purchased_rank_points)
    );
  }, 0);
}
function getNationalTable(configuration: P3Configuration, program: ProgramHeading[]) {
  let points = getPoints(configuration.categories, true, program);
  points = sortConfigurationPoints(points);
  return points;
}
function getRegionalTable(configuration: P3Configuration, program: ProgramHeading[]) {
  let points = getPoints(configuration.categories, false, program);
  points = sortConfigurationPoints(points);
  return points;
}
export {
  getNationalPoints,
  getRegionalPoints,
  getNationalTable,
  getRegionalTable,
  getPointsData,
  getPoints
};
